import { Component } from '@angular/core';

@Component({
  selector: 'app-contact-sales-form-skeleton-loader',
  templateUrl: './contact-sales-form-skeleton-loader.component.html',
  standalone: false,
})
export class ContactSalesFormSkeletonLoaderComponent {}
